import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TblAbfallartTypCreateComponent } from '../../tbl_abfallart_typ/create/create.component';
import { TblAvvCreateComponent } from '../../tbl_avv/create/create.component';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblAbfallartEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
		@Optional() public config?: DynamicDialogConfig,
		@Optional() public ref?: DynamicDialogRef,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate, config, ref);

		this.apiUrl = 'TblAbfallart';
		this.name = 'MENU.ABFALLART';
		this.url = '/' + PATH.ABFALLART;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
			],
			[
				{ type: 'object', key: 'typ_id', required: false, width: 400, apiUrl: 'TblAbfallartTyp', createComponent: TblAbfallartTypCreateComponent },
				{ type: 'object', key: 'avv_id', required: false, width: 400, apiUrl: 'TblAvv', createComponent: TblAvvCreateComponent },
				{ type: 'object', key: 'avvE_id', required: false, width: 400, apiUrl: 'TblAvv', createComponent: TblAvvCreateComponent },
				{ type: 'object', key: 'avvA_id', required: false, width: 400, apiUrl: 'TblAvv', createComponent: TblAvvCreateComponent },
				{ type: 'text', key: 'barcode', required: false, width: 400 },
				{ type: 'text', key: 'barcode_text', required: false, width: 400 },
				{ type: 'numeric', key: 'barcode_ziffer', required: false, width: 400 },
				{ type: 'numeric', key: 'check_barcode_ziffer_index', required: false, width: 400 },
				{ type: 'numeric', key: 'schuettungsstopp_modus', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}
}
